const modalContent = {
    IQ: {
        id: 'IQ',
        title: '請確認',
        content: '因所選變更項目需要填寫投資屬性問卷，系統將自動加入在此次變更當中',
        confirmButton: '確認',
        closeicon: false,
        cancelButton: '取消',
    },
    GOIQ: {
        id: 'IQ',
        title: '請確認',
        content: '您即將前往投資屬性問卷平台，完成後系統將自動導回線上交易進行後續變更',
        confirmButton: '前往',
        closeicon: false,
        cancelButton: '取消',
    },
    A1A2: {
        id: 'A1A2',
        title: '請確認',
        content: '您的保單目前緩繳中，若欲申請變更【目標/計畫保費、配置比例暨繳別變更】請先申請【終止保費緩繳】。<br/>若確定申請【終止保費緩繳】將離開本作業畫面，將帶您進入網頁版【線上交易專區】，請重新登入並重新選擇變更項目。',
        confirmButton: '前往',
        cancelButton: '取消',
        closeicon: false,
        isErrorButton: false,
    },
    A1A2_2: {
        id: 'A1A2_2',
        title: '請確認',
        content: '您的保單保費繳費狀態目前緩繳中，若欲申請變更【目標/計畫保費暨配置比例/繳別變更】，請先同時申請「終止保費緩繳」。',
        confirmButton: '確認',
        closeicon: false,
        isErrorButton: false,
    },
    A6A7: {
        id: 'A6A7',
        title: '請確認',
        content: '若同時辦理「部分投資終止」及「投資標的轉換」時，本公司作業將先執行「部分投資終止」交易後，再進行「投資標的轉換」交易。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: false,
    },
    A5A6: {
        id: 'A5A6',
        title: '請確認',
        content: '單筆增額/不定期投資金額申請不可與投資標的轉換同時辦理變更！',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    A5A7: {
        id: 'A5A7',
        title: '請確認',
        content: '單筆增額/不定期投資金額申請不可與部分投資終止同時辦理變更！',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    B1C1: {
        id: 'B1C1',
        title: '請確認',
        content: '保單繳清不可與繳別變更同時辦理變更！',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    A6A9: {
        id: 'A6A9',
        title: '請確認',
        content: '辦理【部份投資終止】後，保單帳戶價值內之新台幣貨幣帳戶為0，故無法申請新台幣貨幣帳戶定期定額投資標的轉換，請確認後重新輸入。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    A7A9: {
        id: 'A7A9',
        title: '請確認',
        content: '辦理【投資標的轉換】後，保單帳戶價值內之新台幣貨幣帳戶為0，故無法申請新台幣貨幣帳戶定期定額投資標的轉換，請確認後重新輸入。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    B1C2: {
        id: 'B1C2',
        title: '請確認',
        content: '辦理「繳別變更」變更項目時，「清償自動墊繳保費本息」變更項目需一起辦理',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    B1C2_2: {
        id: 'B1C2_2',
        title: '請確認',
        content: '辦理「繳別變更」需同時辦理「全部清償自動墊繳保費本息」',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    C3C2: {
        id: 'C3C2',
        title: '請確認',
        content: '辦理「免核增額」變更項目時，「清償自動墊繳保費本息」變更項目需一起辦理',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    IQYEAR: {
        id: 'IQYEAR',
        title: '請確認',
        content: '<p class="text-error">轉入之基金標的，僅可選取與您投資屬性相符之基金標的，請確認</p>',
        confirmButton: '確認',
        closeicon: false,
        isErrorButton: false,
    },
    C1C2: {
        id: 'C1C2',
        title: '請確認',
        content: '「保單繳清」不可與「清償自動墊繳保費本息」同時辦理變更，請調整您的變更選項。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    C1C3: {
        id: 'C1C3',
        title: '請確認',
        content: '「保單繳清」不可與「免核增額」同時辦理變更，請調整您的變更選項。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    C1C4: {
        id: 'C1C4',
        title: '請確認',
        content: '「保單繳清」不可與「自動墊繳意願變更」同時辦理變更，請調整您的變更選項。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    B2C1: {
        id: 'B2C1',
        title: '請確認',
        content: '「保單繳清」不可與「紅利/增值回饋分享金給付方式變更」同時辦理變更，請調整您的變更選項。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    C1D1: {
        id: 'C1D1',
        title: '請確認',
        content: '「保單繳清」不可與「自行繳費申請」同時辦理變更，請調整您的變更選項。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    B4AD: {
        id: 'B4AD',
        title: '請確認',
        content: '「電子通知單服務」不可與「保單帳戶價值通知方式變更」同時辦理變更，請調整您的變更選項。',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    MSG50: {
        id: 'MSG50',
        title: '請確認',
        content: '<ul style="list-style-type:decimal;padding-left:1em;"><li>【富邦NASDAQ-100證券投資信託基金】(標的代碼：F0662)進行受益憑證分割作業，分割比率為1比5，將於115/07/29~115/08/04停止買賣，新受益憑證換發基準日為115/08/04。</li><li>本公司於基金停止買賣期間，可受理申購與贖回申請，交易處理將比照基金休市作業規範，相關交易延後至換發基準日進行；贖回交易依申請當日申請之單位數辦理，依照基準日後最新公告淨值計算贖回金額。</li><li>本基金停止買賣期間若有辦理基金相關保全變更（例如：部分投資終止、投資標的轉換、單筆增額等）皆因基金暫停交易無法立即成交，相關交易將延後至換發基準日進行，且同一保單皆無法再受理其餘保全變更。</li></ul>',
        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
    PVTYPEB: {
        id: 'PVTYPEB',
        title: '請確認',
        content: '<ul style="list-style-type:decimal;padding-left:1em;"><li>提醒您，勿聽信高報酬、穩賺不賠等「假投資」之詐騙話術，於接獲來路不明投資管道、網路連結或加Line投資時，請至警政署165全民防詐網(https://165.npa.gov.tw/)進一步查證真實性，遠離詐騙陷阱，守護您與家人的財物安全。</li></ul>',        confirmButton: '確定',
        closeicon: false,
        isErrorButton: true,
    },
};

Object.freeze(modalContent);
export default modalContent;
